import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=b99e4198&scoped=true&"
import script from "./Popper.vue?vue&type=script&lang=js&"
export * from "./Popper.vue?vue&type=script&lang=js&"
import style0 from "./Popper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Popper.vue?vue&type=style&index=1&id=b99e4198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99e4198",
  null
  
)

export default component.exports